import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../api';
import { AppState } from '../../store/models/app-state';
import { Contact } from '../models/contact';

export const RECEIVE_CONTACT_DETAILS = 'RECEIVE_CONTACT_DETAILS';
export const CONTACT_DETAILS_NOT_FOUND = 'CONTACT_DETAILS_NOT_FOUND';
export const RECEIVE_CONTACTS = 'RECEIVE_CONTACTS';
export const RECEIVE_CONTACTS_SEARCH = 'RECEIVE_CONTACTS_SEARCH';
export const REQUEST_CONTACT_DETAILS = 'REQUEST_CONTACT_DETAILS';
export const REQUEST_CONTACTS = 'REQUEST_CONTACTS';

export const receiveContacts = (contacts: Contact[]) => {
    return {
        type: RECEIVE_CONTACTS,
        contacts,
    };
};

export const requestContactDetails = () => {
    return {
        type: REQUEST_CONTACT_DETAILS,
    };
};

export const receiveContactsSearchResult = (contacts: Contact[]) => {
    return {
        type: RECEIVE_CONTACTS_SEARCH,
        contacts,
    };
};

export const fetchContactInfo = (contactId: number, accountId?: number, showTopics?: boolean) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(requestContactDetails());

        const response = await api.contact.getContactInfo(contactId, accountId, showTopics);

        if (response.success && response.result) {
            dispatch({ type: RECEIVE_CONTACT_DETAILS, contact: response.result });
        } else {
            dispatch({ type: CONTACT_DETAILS_NOT_FOUND, contactId });
        }
    };
};

export const fetchContacts = () => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: REQUEST_CONTACTS });

        const response = await api.contact.cget(getState().poolAccount.id);

        if (response.success) {
            dispatch(receiveContacts(response.result.items));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const searchContacts = (searchParams: URLSearchParams) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: REQUEST_CONTACTS });

        const response = await api.contact.search(searchParams);

        if (response.success) {
            dispatch(receiveContactsSearchResult(response.result.items));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
